/* returns <img> tag with @jkr */
const ripBigImageFromBody = (body) => {
    const tags = body.getElementsByTagName('img');
    const img = tags.item(tags.length - 1);
    img.parentNode.removeChild(img);

    return img;
}

const createBodyFromHtml = (html) => {
    const body = document.createElement('div');
    body.innerHTML = refactorUrls(html);
    return body;
}

/* changes wp urls to be app urls @jkr */
const refactorUrls = (html) => {
    html = html.replace(/<a/ig, `<a class="screen-option" onclick="window.moderateATags(event);" `);
    return html;
}

const isIphoneX = () => {
    try {
        if (window.cordova) {
            const iphoneModel = window.device.model;
            // console.log('iphoneModel',iphoneModel);
            const m = iphoneModel.match(/iPhone(\d+),\d+/);
            if (m && m.length > 1) {
                const model = +m[1];

                if (model >= 10) { // is iphone X capable @jkr
                    return true;
                }
            }
        }
    } catch (e) {
        console.warn(e);
    }

    return false;
}

const credHeaders = () => {
    return new Headers({
        'Authorization': 'Basic ' + btoa(`dawna:123Dawna!`),
        'Content-Type': 'application/x-www-form-urlencoded'
    });
}

const facebookAppId = 2341753602511564;

const time24hr = 1000 * 60 * 60 * 24;
const time1wk = time24hr * 7;

// const urlBypassHtpasswd = (url) => {
//     // url = url.replace('http://', `http://${creds.user}:${creds.pass}@`);
//     console.log(url)

//     return url;
// }

export default {
    ripBigImageFromBody,
    createBodyFromHtml,
    refactorUrls,
    // creds,
    // urlBypassHtpasswd
    credHeaders,
    facebookAppId,
    time24hr,
    time1wk,
    isIphoneX
}